import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import AsyncSelect from 'react-select/async';

import Menu from './menu';
import ValueContainer from 'helpers/react_select/components/search_value_container';
import { getInlineStyles } from 'helpers/react_select_helpers';
import { debounce } from 'lodash';

const styles = getInlineStyles(ValueContainer.styleOverrides);

export default function AutoCompleteInput({
  className,
  labelName = 'label',
  placeholder,
  value,
  valueName = 'id',
  onChange,
  onSearch,
}) {
  const debouncedSearch = useCallback(debounce(onSearch, 500), [onSearch]);

  const loadOptions = (query, callback) => {
    if (query) {
      debouncedSearch(query, callback);
    } else {
      return callback([]);
    }
  };

  return (
    <AsyncSelect
      className={className}
      classNamePrefix=""
      components={{ DropdownIndicator: null, Menu, ValueContainer }}
      getOptionLabel={option => (option[labelName])}
      getOptionValue={option => (option[valueName])}
      loadOptions={loadOptions}
      placeholder={placeholder}
      styles={styles}
      value={value}
      onChange={onChange}
    />
  );
}

AutoCompleteInput.propTypes = {
  className: PropTypes.string,
  labelName: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.object,
  valueName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};
